const handleLoading = (store) => {
  store.subscribeAction({
    before: () => {
      store.commit("Alert/SET_IS_LOADING", true, { root: true });
    },
    after: () => {
      store.commit("Alert/SET_IS_LOADING", false, { root: true });
    },
    error: () => {
      store.commit("Alert/SET_IS_LOADING", false, { root: true });
    },
  });
};

export default handleLoading;
